import { render, staticRenderFns } from "./CommunityPolls.vue?vue&type=template&id=7427d881&"
import script from "./CommunityPolls.vue?vue&type=script&lang=js&"
export * from "./CommunityPolls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports